import { combineReducers } from "redux";
import liveSwitchState from "../../../LiveSwitch/liveSwitchReducer";
import apiError from "../../../Shared/Redux/Reducers/apiErrorReducer";
import accessInfo from "./accessInfoReducer";
import activeMentee from "./activeMenteeReducer";
import activeObservers from "./activeObserversReducer";
import apiCallsInProgress from "../../../Shared/Redux/Reducers/apiStatusReducer";
import canLeave from "./canLeaveReducer";
import chats from "./chatsReducer";
import connectionQuality from "../../../Shared/Redux/Reducers/connectionQualityReducer";
import currentPosition from "./currentPositionReducer";
import deviceId from "./deviceIdReducer";
import externalObservers from "./externalObserverReducer";
import fullscreen from "./fullscreenReducer";
import invalidCode from "./invalidCodeReducer";
import liveSwitchToken from "./liveSwitchTokenReducer";
import localizations from "./localizationsReducer";
import mentor from "./mentorReducer";
import notifications from "../../../Shared/Redux/Reducers/notificationsReducer";
import numberInQueue from "./numberInQueueReducer";
import onPremiseSettings from "./onPremiseSettingsReducer";
import order from "./orderReducer";
import permissions from "./permissionsReducer";
import photos from "./photosReducer";
import recordingState from "./recordingStateReducer";
import registrations from "./registrationReducer"
import scheduleSlots from "./scheduleSlotsReducer";



const rootReducer = combineReducers({
    localizations,
    order,
    estimatedStart: null as any,
    numberInQueue,
    chats,
    accessInfo,
    photos,
    apiCallsInProgress,
    liveSwitchState,
    mentor,
    currentPosition,
    deviceId,
    liveSwitchToken,
    notifications,
    fullscreen,
    permissions,
    canLeave,
    invalidCode,
    scheduleSlots,
    apiError,
    activeObservers,
    activeMentee,
    recordingState,
    onPremiseSettings,
    connectionQuality,
    registrations,
    externalObservers
});

export default rootReducer;
